// extracted by mini-css-extract-plugin
module.exports = {"search":"styles_search__hbMo4","btnSearch":"styles_btnSearch__AwGZC"};